import React from 'react'

import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-enterprise'
import { CButton, CFormInput, CRow, CCol, CBadge, CModal, CModalHeader, CDropdown, CModalBody, CDropdownMenu, CDropdownItem, CDropdownToggle, CModalFooter, CFormLabel } from '@coreui/react'

import { LicenseManager } from 'ag-grid-enterprise'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import './AgGridStyle.css'

LicenseManager.setLicenseKey('For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-21_December_2022_[v2]_MTY3MTU4MDgwMDAwMA==72993978b037cf7071dd20d6c116bd5d')

import 'ag-grid-community/styles//ag-grid.css'
import 'ag-grid-community/styles//ag-theme-material.css'
import { useState, useMemo, useRef, useCallback, useEffect } from 'react'
import { CallReceived } from '@mui/icons-material'

const CustomAgGrid = ({ options, btnList = [], rowClickedFn, callFrom = 'CallCenter', toggleFilter = false, className = '' }) => {
  const gridRef = useRef()
  const history = useHistory()
  const [quickFilterText, setQuickFilterText] = useState('')

  const [updateBtnClicked, setupdateBtnClicked] = useState('')
  const sideBar = {
    toolPanels: [
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        minWidth: 150,
        maxWidth: 200,
        width: 200,
      },
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        position: 'top',
      },
    ],
    position: 'right',
    suppressFiltersToolPanel: true,
  }
  const suppressRowHoverHighlight = false
  const columnHoverHighlight = false
  const rowClassRules = useMemo(() => {
    return {
      // row style function
      completed: (params) => {
        var numSickDays = params.data.Status.trim()
        return numSickDays == 'Completed'
      },
      indraft: (params) => {
        var numSickDays = params.data.Status.trim()
        return numSickDays == 'In Draft'
      },
      // row style expression
      pending: (params) => {
        var numSickDays = params.data.Status.trim()
        return numSickDays == 'Pending'
      },
    }
  }, [])

  const fnRowClicked = (e) => {
    // if (callFrom == "CallCenter") {
    //   let test = e.data.Diagnosis

    //   let diagnosis = test.split(',')

    //   window.DiagnosList = diagnosis
    //   window.PatientData = e.data

    //     history.push("/questions")
    // } else {
    rowClickedFn(updateBtnClicked, e.data)
    // }

    // else if(callFrom == "Facility" || callFrom == "Patient" || callFrom == "Insurance") {
    //   rowClickedFn(updateBtnClicked,e.data)

    // }else {
    //   rowClickedFn(e.data)
    // }
  }
  const defaultColDef = useMemo(() => {
    return {
      enableRowGroup: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1,
      minWidth: 300,
    }
  }, [])

  const gridOptions = {
    sideBar: {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          position: 'top',
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          position: 'top',
        },
      ],
      defaultToolPanel: '',
    },
    getRowStyle: (params) => {
      if (params.node.footer) {
        return { fontWeight: 'bold' }
      }
    },
    aggFuncs: {
      sum: customSum,
    },
  }
  function customSum({ values }) {
    let sum = 0
    values.forEach((value) => {
      if (value !== null && value !== undefined) {
        // Convert the value to an integer before summing
        const intValue = parseInt(value, 10)
        if (!isNaN(intValue)) {
          sum += intValue
        }
      }
    })
    return sum
  }

  function parseDate(str) {
    const monthNames = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
    }

    const [month, day, year] = str.split(' ')

    return new Date(year, monthNames[month], day)
  }

  const onBtExport = useCallback(() => {
    gridRef.current.api.exportDataAsExcel()
  }, [])
  const excelStyles = useMemo(() => {
    return [
      {
        id: 'multiline',
        alignment: {
          wrapText: true,
        },
      },
    ]
  }, [])

  const [data, setData] = useState([])
  const [columns, setColumns] = useState([])

  useEffect(() => {
    if (options != '') {
      let temp = {}

      if (typeof options === typeof '') {
        let temp1 = JSON.parse(options)
        temp = temp1.Data
      } else {
        temp = options
      }

      try {
        let c = []
        for (let j = 0; j < Object.keys(temp[0]).length; j++) {
          if (j == 0) {
            continue
          } else {
            c.push({
              field: Object.keys(temp[0])[j],
              headerName: Object.keys(temp[0])[j],
              filter: 'agMultiColumnFilter',
              filterParams: {
                filters: [
                  {
                    filter: 'agTextColumnFilter',
                    filterParams: {
                      buttons: ['reset'],
                      //suppressAndOrCondition: true
                    },
                  },
                  {
                    filter: 'agNumberColumnFilter',
                    filterParams: {
                      buttons: ['reset'],
                      //suppressAndOrCondition: true
                    },
                  },
                  {
                    filter: 'agSetColumnFilter',
                    filterParams: {
                      buttons: ['reset'],
                      //suppressAndOrCondition: true
                    },
                  },
                  {
                    filter: 'agDateColumnFilter',
                    filterParams: {
                      buttons: ['reset'],
                      // provide comparator function
                      comparator: (filterLocalDateAtMidnight, cellValue) => {
                        const dateAsString = cellValue

                        if (dateAsString == null && dateAsString == '') {
                          return 0
                        }
                        let today = new Date(cellValue)

                        if (isNaN(today.getTime())) {
                          today = parseDate(dateAsString)
                          if (isNaN(today.getTime())) {
                            return null
                          }
                        }
                        if (today < filterLocalDateAtMidnight) {
                          return -1
                        } else if (today > filterLocalDateAtMidnight) {
                          return 1
                        }
                        return 0
                      },
                    },
                  },
                ],
              },
            })
          }
        }

        btnList.forEach((element) => {
          c.push({
            width: 120,
            pinned: 'right',
            maxWidth: 120,
            field: element.Name,
            cellRenderer: BtnCellRenderer,
            cellRendererParams: {
              clicked: element.FunctionName,
              label: element.Name,
              clickFn: element.FunctionName,
              btnData: setupdateBtnClicked,
            },
          })
        })

        setColumns(c)
        setData(temp)
      } catch (e) {}
    }
  }, [options, toggleFilter])
  return (
    <>
      {/* <CRow>
        <CCol xs={3}>
          <CFormInput type="text" placeholder="Search" onChange={(e) => setQuickFilterText(e.target.value)} />
        </CCol>
        </CRow> */}
      <div
        className={`ag-theme-material ${className}`.trim()}
        style={{
          height: '38rem',
        }}
      >
        {/* <CButton onClick={onBtExport} variant="outline" color="success"
            style={{ margin: '5px 0px', fontWeight: 'bold' }}>
        Export to Excel
      </CButton> */}

        <AgGridReact
          rowData={data}
          columnDefs={columns}
          suppressRowHoverHighlight={suppressRowHoverHighlight}
          defaultColDef={defaultColDef}
          onRowSelected={(e) => console.log()}
          onRowClicked={(e) => fnRowClicked(e)}
          pagination={true}
          columnHoverHighlight={columnHoverHighlight}
          suppressRowClickSelection={true}
          groupSelectsChildren={true}
          quickFilterText={quickFilterText}
          columnGroupPanelShow={'always'}
          enableRangeSelection={'true'}
          gridOptions={gridOptions}
          rowSelection={'multiple'}
          rowGroupPanelShow={'always'}
          sideBar={sideBar}
          suppressAutoSize={false}
          ref={gridRef}
          excelStyles={excelStyles}
        />
      </div>
    </>
  )
}

const BtnCellRenderer = (data) => {
  useEffect(() => {}, [])
  return (
    <>
      <CButton
        onClick={(e) => {
          data.btnData(data.label.toUpperCase())
        }}
        variant="outline"
        color={data.label == 'Checkout' ? 'success' : data.label == 'Edit' ? 'warning' : data.label == 'Delete' ? 'danger' : 'primary'}
      >
        {data.label}
      </CButton>
    </>
  )
}

export default CustomAgGrid
